import { AppRouter } from "./router";
import { ToastContainer } from "./components/ui/Toast";
import { TourProvider } from "./components/tour";

function App() {
  return (
    <>
      <AppRouter />
      <ToastContainer />
      <TourProvider />
    </>
  );
}

export default App;
